module.exports = __webpack_public_path__ + "static/냉장신선식품-ed77c6a76db5a9005f4e554c4fea46a9.jpg";